import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import Header from './Header';

const QRLoginPage = ({ onLogin }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto redirect after 7 seconds simulating successful authentication
    const timer = setTimeout(() => {
      const storedUser = JSON.parse(localStorage.getItem('demoUser') || '{}');
      if (storedUser.email) {
        onLogin(storedUser.email);
        navigate('/dashboard');
      } else {
        // If no user data, redirect to register
        navigate('/register');
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, onLogin]);

  // Generate QR code data for EUDI Wallet authentication
  const qrData = JSON.stringify({
    type: 'authentication_request',
    verifier: 'floors-merchant',
    credential_type: 'LoginCredential',
    challenge: Math.random().toString(36).substring(7),
    timestamp: new Date().toISOString()
  });

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Header showNavigation={false} showAuthButtons={false} />

      {/* Main Content */}
      <main style={{ padding: '60px 0' }}>
        <div className="container">
          <div className="card">
            <div className="qr-container">
              <h2 style={{ 
                marginBottom: '30px', 
                color: '#333',
                textAlign: 'center'
              }}>
                Scan the QR Code with your EUDI Wallet
              </h2>
              
              <div style={{ 
                padding: '20px',
                backgroundColor: 'white',
                border: '2px solid #ddd',
                borderRadius: '12px'
              }}>
                <QRCode 
                  value={qrData}
                  size={200}
                  level="M"
                />
              </div>
              
              <div className="powered-by">
                Powered by <a href="#" style={{ color: '#007bff' }}>UNICORN</a>
              </div>
              
              <p style={{ 
                color: '#666', 
                textAlign: 'center', 
                marginTop: '20px',
                fontSize: '14px'
              }}>
                Scan this QR code with your EUDI Wallet to authenticate.<br/>
                You will be automatically logged in once verification is complete.
              </p>
              
              <div style={{ 
                marginTop: '30px',
                padding: '15px',
                backgroundColor: '#e3f2fd',
                borderRadius: '8px',
                border: '1px solid #2196f3'
              }}>
                <p style={{ 
                  color: '#1565c0', 
                  textAlign: 'center', 
                  margin: 0,
                  fontSize: '14px'
                }}>
                  🔄 Authenticating... Please wait
                </p>
              </div>
              
              <div style={{ marginTop: '20px' }}>
                <Link to="/login" className="btn btn-secondary">
                  Back to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default QRLoginPage;

